import React, { useId } from 'react';

// On/off switch built on a real checkbox, so forms, labels and tests keep
// working (FECOA-2174). Put it inside a <label>, or use ToggleRow.
export const Switch = ({ className = '', ...inputProps }) => (
  <span className={`relative inline-flex h-5 w-9 flex-shrink-0 items-center ${inputProps.disabled ? 'opacity-60' : ''} ${className}`}>
    <input type="checkbox" className="peer absolute inset-0 m-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed" {...inputProps} />
    <span
      aria-hidden="true"
      className="pointer-events-none h-5 w-9 rounded-full bg-gray-200 transition-colors peer-checked:bg-primary-600 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500/60 peer-focus-visible:ring-offset-2 dark:bg-white/15 dark:peer-checked:bg-primary-500 dark:peer-focus-visible:ring-offset-gray-900"
    />
    <span
      aria-hidden="true"
      className="pointer-events-none absolute left-0.5 h-4 w-4 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-150 peer-checked:translate-x-4"
    />
  </span>
);

// A row with a title, an optional description and a switch on the right.
// The switch is named by the title only, so getByLabelText('Active') still works.
export const ToggleRow = ({ title, description, className = '', children, ...inputProps }) => {
  const id = useId();
  return (
    <div className={`option-row ${className}`}>
      <label htmlFor={inputProps.id || id} className="min-w-0 flex-1 cursor-pointer">
        <span id={`${id}-title`} className="block text-[13.5px] font-medium text-gray-900 dark:text-gray-50">{title}</span>
        {description && (
          <span id={`${id}-desc`} className="mt-0.5 block text-[12.5px] leading-relaxed text-gray-500 dark:text-gray-400">
            {description}
          </span>
        )}
      </label>
      <Switch
        id={inputProps.id || id}
        aria-labelledby={`${id}-title`}
        aria-describedby={description ? `${id}-desc` : undefined}
        {...inputProps}
      />
      {children}
    </div>
  );
};

export default Switch;
